const getMappableValue = function (subject) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof subject === 'function' ? subject(...params) : subject;
};
export default getMappableValue;